import * as React from 'react';
import IPeopleVerificationList from './IPeopleVerificationList';
import PersonVerificationStatus from '../PersonVerificationStatus/PersonVerificationStatus';

import * as appStyle from '../../AppStyle.module.scss';
import * as style from './PeopleVerificationListStyle.module.scss'

export default class PeopleVerificationList extends React.Component<IPeopleVerificationList> {
  render() {
    const { header } = this.props;

    return (
      <React.Fragment>
        <h2 className={appStyle.companySectionHeader}>{header}</h2>
        {this.renderPeople()}
      </React.Fragment>
    );
  }

  private renderPeople  = () => this.props.peopleList.map((person) => {
    return (
      <PersonVerificationStatus
        // @ts-ignore - ongoing refactor, updating TS
        companySlug={this.props.slug}
        key={person.slug}
        {...person}
        owner={this.props.owner}
      />
    );
  })
}
